<template>
  <div class="active">
    <div class="c-modal__background" @click="closeMessageModal"></div>
    <div class="c-modal p-client-page-message__modal">
      <div class="c-modal__header p-client-page-message__modal-header">
        <div
          class="c-modal__header__close p-client-page-message__modal-close"
          @click="closeMessageModal"
        />
        送信の確認
      </div>
      <div class="c-modal__body p-client-page-message__modal-body">
        <p>
          求職者名:
          <span class="u-font-bold">{{ applicantName }}</span>
        </p>
        <p class="u-mt8">送信内容</p>
        <div
          class="u-mt8 u-p8 c-card -border u-fs12 u-overflow-y-scroll u-max-h300"
        >
          <div v-html="formattedEmailContent"></div>
        </div>
        <div
          v-if="attachmentFilenames.length > 0"
          class="u-py4 u-flex -scroll-x u-gap8"
        >
          <span
            v-for="(attachment, i) in attachmentFilenames"
            :key="i"
            class="attachment-label"
          >
            {{ attachment }}
          </span>
        </div>
        <p class="u-mt16 u-lh24">
          上記の内容で送信します。<br />
          求職者の名前や内容の確認をしてください。
        </p>
      </div>
      <div class="c-modal__body p-client-page-message__modal-body">
        <div class="p-client-page-message__modal-action-button">
          <button
            type="button"
            class="c-button -green -middle p-client-page-message__modal-button"
            @click="submitModal"
          >
            送信
          </button>
          <div
            class="c-button -white -middle p-client-page-message__modal-button"
            @click="closeMessageModal"
          >
            やめる
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    applicantName: {
      type: String,
      required: true,
    },
    emailContent: {
      type: String,
      required: true,
    },
    attachmentFilenames: {
      type: Array,
    },
  },
  methods: {
    submitModal() {
      this.$emit('submit');
    },
    closeMessageModal() {
      this.$emit('close');
    },
  },
  computed: {
    formattedEmailContent() {
      return this.emailContent.replace(/\n/g, '<br>');
    },
  },
};
</script>
